import { Column } from "primereact/column";
import MeaLink from "../../../../components/MeaLink";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import CreateClasseModal from "./CreateClasseModal";
import classesAPI from "../../../../services/classes";
import UpdateClasseModal from "./UpdateClasseModal";
import { Dropdown } from "primereact/dropdown";
import levelsAPI from "../../../../services/levels";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_LEVELS } from "../../../../permissions";
import { useAuthContext } from "../../../../hooks/useAuthContext";

const ClassesListComponent = forwardRef((props, ref) => {
  const { selectedFields, filter, showFilterButton, showAddButton, showToolbar, schoolId, trainingId } = props;
  const { hasPermission } = useAuthContext();
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();

  const accessToken = "";
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  //
  let selectedData = {
    name: selectedFields?.name ?? true,
    presentation: selectedFields?.presentation ?? true,
    totalStudent: selectedFields?.totalStudent ?? true,
    level: selectedFields?.level ?? true,
    maxCapacity: selectedFields?.maxCapacity ?? true,
    edit: selectedFields?.edit ?? true
  };
  //
  const [state, setState] = useUrlState({
    classesPage: "1",
    classesPageSize: "50",
    classesFilter: JSON.stringify({ level_id: filter?.level_id || "" }),
  });
  const [classe, setClasse] = useState(null);
  //
  const queryList = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.classesFilter)
  );
  //
  const levelsQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  const setFilter = (field, value) => {
    let currentFilter = state?.classesFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      classesPage: 1,
      classesFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  const filterCombobox = (options, query, field) => {
    return (
      <Dropdown
        value={query?.data?.data?.find(
          (obj) => obj.id === JSON.parse(state.classesFilter)[field]
        )}
        options={query?.data?.data}
        optionLabel="name"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
          setFilter(field, e.value?.id || "");
        }}
        //itemTemplate={statusItemTemplate}
        placeholder="Séléctionner"
        className="p-column-filter"
        showClear
      />
    );
  };

  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <MeaButton
          label="Créer une classe"
          icon="pi pi-plus"
          size="small"
          className="p-button mr-2 action"
          onClick={() => {
            createModalRef.current.show(() => {
              queryList.refetch();
            });
          }}
          data-pr-tooltip="Nouvelle classe"
          permission={PERMISSION_TRAINING_CLASSES.CREATE}
        />
      )}
    </div>
  );
  //
  return (
    <>
      <CreateClasseModal ref={createModalRef} levelId={filter?.level_id} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
      <MeaDataTable
        query={queryList}
        serviceAPI={classesAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        accessToken={accessToken}
        names={{ pagination: "classes", singular: "classe", plural: "classes" }}
        startToolbarTemplate={startToolbarTemplate}
        showFilterButton={showFilterButton}
        showToolbar={showToolbar !== false}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_CLASSES.DELETE)}
        setPage={setPage}
        setPageSize={setPageSize}
        rowClassName={(rowData) => {
          if (rowData.max_capacity > 0) {
            if (rowData.total_students === rowData.max_capacity) {
              return 'bg-green-100';
            } else if (rowData.total_students < rowData.max_capacity) {
              return 'bg-orange-100';
            } else if (rowData.total_students > rowData.max_capacity) {
              return 'bg-red-100';
            } else {
              return '';
            }
          }
          return '';
        }}
        paginatorPosition="top"
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        {selectedData.name &&
          <Column
            field="name"
            header="Classe"
            body={(item) => (
              <MeaLink
                to={"/school/" + schoolId + "/admin/trainings/" + trainingId + "/classes/" + item.id}
                permission={PERMISSION_TRAINING_CLASSES.GET}
              >
                {item.name}
              </MeaLink>
            )}
          ></Column>
        }
        {selectedData.level &&
          <Column
            field="level"
            header="Niveau"
            body={(item) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/levels/" +
                  item?.level?.id
                }
                permission={PERMISSION_TRAINING_LEVELS.GET}
              >
                {item?.level?.name}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, levelsQuery, "level_id")
            }
          ></Column>
        }
        {selectedData.presentation &&
          <Column field="presentation" header="Presentation"></Column>
        }
        {selectedData.totalStudent &&
          <Column field="total_students" header="Nbr d'élèves"></Column>
        }
        {selectedData.maxCapacity &&
          <Column field="max_capacity" header="Capacité maximale"></Column>
        }
        {selectedData.edit &&
          <Column
            body={(item) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {
                    setClasse(item);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_CLASSES.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        }
      </MeaDataTable>
      <UpdateClasseModal ref={updateModalRef} classe={classe} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
    </>
  );
});

export default ClassesListComponent;
